import { BaseRouteService } from "core/services";

class WoundDressingRouteService extends BaseRouteService {
    constructor() {
        super("woundDressings");
    }

    find(filter) {
        return super.find(
            this.base + "/{?woundId,searchQuery,page,rpp,sort,embed,fields}",
            filter
        );
    }

    get(id, options) {
        return super.get(this.base + "/{id}/{?embed,fields}", id, options);
    }

    update(resource) {
        return super.update(this.base + "/{id}", resource);
    }

    delete(resource) {
        return super.delete(this.base + "/{id}", resource);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    createAdditionalValidations(resource) {
        return super.create(this.base + "/additional-validation", resource);
    }

    getValidationCheck(resource) {
        return super.create(this.base + "/validation-check", resource);
    }
}

export default WoundDressingRouteService;
